import React from 'react';

import { BuilderBlocks } from '@builder.io/react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { desktop } from '~/techstyle-shared/react-components';

const StyledUnorderedList = styled.ul`
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    ${desktop`
      flex-wrap: wrap;
      flex-direction: row;
      align-items: unset;
    `}

  ${({ $gapBetweenListItems }) =>
    $gapBetweenListItems >= 0 &&
    css`
      gap: ${$gapBetweenListItems}px;
    `}
`;

function BuilderListRow({
  builderBlock: { id, children },
  gapBetweenListItems,
}) {
  return (
    <StyledUnorderedList
      data-builder-component-type="list_row"
      $gapBetweenListItems={gapBetweenListItems}
    >
      <BuilderBlocks parentElementId={id} blocks={children} />
    </StyledUnorderedList>
  );
}

BuilderListRow.propTypes = {
  builderBlock: PropTypes.shape({
    id: PropTypes.string,
    children: PropTypes.array,
  }),
  /**
   * @default 24
   * The numeric value of gap between list items in pixels.
   * eg. 24, which will create a 24px gap between each list item.
   */
  gapBetweenListItems: PropTypes.number,
};

export default BuilderListRow;
